import React from "react";
import "../styles/About.css";
import { Link } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
const About = () => {
  return (
    <div className="about-container">
      <title>About DoctorBach</title>
      <HelmetProvider>
        <Helmet>
          <title>About DoctorBach</title>
          <meta
            name="description"
            content="Learn about Dr. John R. Bach's website about noninvasive respiratory care for neuromuscular diseases, and why this site exists to spread his life-saving protocols."
          />
          <meta
            name="keywords"
            content="Dr. Bach, DoctorBach, Noninvasive Ventilation, NVS, NIV, Neuromuscular Disease, Respiratory Therapy, DMD, ALS, SMA"
          />
          <meta name="author" content="DoctorBach Team" />
          <meta property="og:title" content="About DoctorBach" />
          <meta
            property="og:description"
            content="Discover the mission behind DoctorBach.com and Dr. Bach’s contributions to noninvasive respiratory care."
          />
          <meta
            property="og:image"
            content="https://doctorbach.com/favicon.png"
          />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://doctorbach.com/about" />
        </Helmet>{" "}
      </HelmetProvider>
      <div className="about-title">
        <h3>About DoctorBach</h3>
      </div>
      {/* Introduction Section */}
      <div className="cent-container">
        <div className="about-introduction">
          <p>
            It may seem very self serving for{" "}
            <Link
              to="/drbach"
              style={{ textDecoration: "none", color: "darkblue" }}
            >
              Dr. Bach
            </Link>{" "}
            to have a "DoctorBach.com" website; however, that is not the case.
            Dr. John R. Bach has done great work in the field and has always
            been a huge proponent of using non-invasive means to treat
            cardio-pulmonary problems affecting kids and adults with
            neuro-muscular diseases.
          </p>
          <p>
            Dr. Bach's protocols and extensive experience is
            valuable--essential--for improving quality of life and length of
            life for those living with neuro-muscular disease. This information
            should be available and easily accessible to as many people as
            possible as it can be the differece between life and death for
            individuals dealing with neuro-muscular diseases.
          </p>
          <p>
            Though the vast majority of information on this site is prepared by
            or at least reviewed by Dr. Bach, he is not responsible for website
            content or maintenance. As with any medical information site...
          </p>
          <p>
            Of course, we'd recommend--if at all possible--consulting with Dr.
            Bach or a physician or respiratory therapist who is familiar with
            Dr. Bach's protocol and techniques. Print out a copy of pertinent
            articles to take to your doctor.
          </p>
          <h4>
            The information on this site should not be taken as medical advice
            for any particular person or condition. Always consult a medical
            professional who is familiar with your condition and history.
          </h4>
        </div>
      </div>
    </div>
  );
};

export default About;
